import { UserProfileModel } from "../../components/profile/shared/profile.model";

export class LoginModel {
  userName: string;
  password: string;
  languageCode: string;
}
export class LanguageModel {
  id: number;
  code: string;
  name: string;
  label: string;
  value: string;
}

export class PushNotificationTokenModel {
  servicUserUId: string;
  userId: number;
  sourceType: string;
  tokenValue: string;
  userAuthToken: string;
}

export class Token {
  AccessToken: string = "";
  ExpiresIn: number = 0;
  UserName: string = "";
  User: UserProfileModel = new UserProfileModel();
}

export class UserNotificationModel {
  uId: string;
  userUId: string;
  appUId : string;
  sourceType: string;
  tokenValue: string;
  serviceCD: string;
  notificationHeader: string;
  notificationBody: string;
  isNotificationSent: boolean;
  isReadNotification: boolean;
  readNotificationDateTime: string;
  createdDateTime : string;
  notificationSentDateTime: string;
  notificationPayload: any;
  hasError: boolean;
  rowNo: number;
  error: string;
  errorTrace: string;
  recordAffected: number;
  entityUId: string;
  validationErrors: any;
  payloadResult : PayloadResult = new PayloadResult();
}

export class PayloadResult {
  viewName: string;
  entityName: string;
  redirectUId: string;
  redirectUrl: string;
  iconUrl: string;
  assignedDateTime: string;
  rejectionTimeInSec: string;
}

export class UserNotificationDataModel {
  data: Array<UserNotificationModel> = [];
  totalRecords: number;
  totalPagesCount: number;
}

export class UnreadNotificationModel {
  unreadNotificationCount: number = 0;
  totalUnreadRideNotificationCount: number;
  totalUnreadHealthNotificationCount: number;
  totalUnreadFoodNotificationCount: number;
  rideTodayNotificationCount: number;
  ridePreviousNotificationCount: number;
  healthTodayNotificationCount: number;
  healthPreviousNotificationCount: number;
  foodTodayNotificationCount: number;
  foodPreviousNotificationCount: number;
  todaysNotification : number;
  previousNotification : number;
}
